import flowRuleApi from '@/api/config/flowRuleApi'
import { queryKeys } from '@/constant/common'
import { UpdateFlowRule } from '@/types/hydraulic'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import useTranslation from '@/hooks/useTranslation'
import { getApiErrorMessage } from '@/helpers'

async function createFlowRule(payload: UpdateFlowRule): Promise<void> {
  await flowRuleApi.create(payload)
}
const useAddFlowRule = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation((payload: UpdateFlowRule) => createFlowRule(payload), {
    onSuccess() {
      queryClient.invalidateQueries([queryKeys.flowRule])
      toast.success(t('AddFlowRuleSuccess'))
    },
    onError: (error: any) => {
      toast.error(getApiErrorMessage(error))
    },
  })
}

export default useAddFlowRule
